import { sdgIconUrl } from '@worldcoo/ui/lib/sdg-icons';

export function SdgIcon(props: { goal: number; className?: string }) {
	const src = sdgIconUrl(props.goal);
	if (!src) return null;
	return <img src={src} alt="" width={40} height={40} className={props.className} />;
}
